import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// import CropImage from "./CropImage";

//import crop
import ModalCrop from "./ModalCrop";

//Import module Modal
import Modal from "react-bootstrap/Modal";

// Import module Services
import TambonService from "../../services/tambon.service";
import farmerService from "../../services/farmer.service";
import authService from "../../services/auth.service";
import externalService from "../../services/external.service";

// Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

//Import module for datePicker
import dayjs from "dayjs";
import { WatDatePicker } from "thaidatepicker-react";

//Import ConfirmAlert
import { confirmAlert } from "react-confirm-alert";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";
import { toast } from "react-toastify";

//Import webCam
import Webcam from "./Webcam";

//Import farmer.css
import "./farmer.css";

const valid = {
  display: "block",
  width: "100%",
  padding: "0.375rem 0.75rem",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: 1.5,
  color: "#212529",
  backgroundColor: "#fff",
  backgroundClip: "padding-box",
  border: "1px solid #ced4da",
  appearance: "none",
  borderRadius: "0.25rem",
  transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
};

const invalid = {
  display: "block",
  width: "100%",
  padding: "0.375rem 0 0.375rem",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: 1.5,
  color: "#212529",
  backgroundColor: "#fff",
  backgroundClip: "padding-box",
  border: "1px solid #dc3545",
  appearance: "none",
  borderRadius: "0.25rem",
  transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  paddingRight: "calc(1.5em + 0.75rem)",
  backgroundImage:
    'url(\'data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="%23dc3545"%3e%3ccircle cx="6" cy="6" r="4.5"/%3e%3cpath stroke-linejoin="round" d="M5.8 3.6h.4L6 6.5z"/%3e%3ccircle cx="6" cy="8.2" r=".6" fill="%23dc3545" stroke="none"/%3e%3c/svg%3e\')',
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right calc(0.375em + 0.1875rem) center",
  backgroundSize: "calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)",
};

function ModaladdFarmer(props) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [prov, setProv] = useState([]);
  // const [proselect, setProselect] = useState("0");
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [hiddenprename, setHiddenprename] = useState(true);
  const [amp, setAmp] = useState([]);
  const [tam, setTam] = useState([]);
  const [hiddenCamera, setHiddenCamera] = useState(true);
  const [showCrop, setShowCrop] = useState(false);

  const [selectedDate, setSelectedDate] = useState("");
  // const [selectedThaiDate, setSelectedThaiDate] = useState("");

  const user = authService.getCurrentUser();

  const handleWatDatePickerChange = (christDate, buddhistDate) => {
    console.log(buddhistDate);
    setSelectedDate(christDate);
    // Check click remove date
    if (christDate) {
      setForm({
        ...form,
        ["birth_date"]: christDate,
      });
    } else {
      setForm({
        ...form,
        ["birth_date"]: "",
      });
    }
    //Set error to Null
    setErrors({
      ...errors,
      ["birth_date"]: null,
    });
  };

  // const user = JSON.parse(sessionStorage.getItem("user"));
  const handleClose = () => {
    initialForm();
    setImage({
      preview: null,
    });
    props.hidden(false);
    setHiddenCamera(true);
  };
  const getProv = () => {
    return Promise.resolve(
      TambonService.get({ pro_id: "0", amp_id: "0", tam_id: "0" })
        .then((response) => {
          setProv(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching Prove: ", error);
        })
    );
  };
  useEffect(() => {
    getProv();
  }, []);

  const getAmp = (prov) => {
    return new Promise(function (resolve, reject) {
      TambonService.get({
        pro_id: prov ? prov : 0,
        amp_id: 0,
        tam_id: 0,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error("error fetching amp: ", error);
          reject(1);
        });
    });
  };
  // useEffect(async () => {
  //   await getAmp(form.prov);
  // }, [form.prov]);

  const handleProvChange = async (prov) => {
    setErrors({
      ...errors,
      ["prov"]: null,
    });
    if (prov && prov != "") {
      await getAmp(prov).then((response) => {
        setAmp(response.data.data);
        setForm({
          ...form,
          ["prov"]: prov,
          ["amp"]: "",
          ["tam"]: "",
        });
      });
    } else {
      setAmp([]);
      setTam([]);
      setForm({
        ...form,
        ["amp"]: "",
        ["tam"]: "",
      });
    }
  };

  const getTam = (prov, amp) => {
    return new Promise(function (resolve, reject) {
      TambonService.get({
        pro_id: prov ? prov : 0,
        amp_id: amp ? amp : 0,
        tam_id: 0,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error("error fetching tam: ", error);
          reject(1);
        });
    });
  };
  // useEffect(async () => {
  //   await getTam(form.prov, form.amp);
  // }, [form.amp]);

  const handleAmpChange = async (prov, amp) => {
    setErrors({
      ...errors,
      ["amp"]: null,
    });
    if (amp && amp != "") {
      await getTam(prov, amp).then((response) => {
        setTam(response.data.data);
        setForm({
          ...form,
          ["amp"]: amp,
          ["tam"]: "",
        });
      });
    } else {
      setTam([]);
      setForm({
        ...form,
        ["tam"]: "",
      });
    }
  };

  function checkID(id) {
    console.log(id.length);
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  }

  const initialForm = () => {
    setSelectedDate("");
    setHiddenprename(true);
    setForm({});
    setErrors({});
  };
  const setField = (field, value) => {
    if (field.files) {
      setImage({
        preview: URL.createObjectURL(field.files[0]),
      });
      setForm({
        ...form,
        [field.name]: field.files[0],
      });
      setShowCrop(true);
    } else {
      if (field.name == "pre_name" && value == "อื่นๆ") {
        setHiddenprename(false);
      } else if (field.name == "pre_name" && value !== "อื่นๆ") {
        setHiddenprename(true);
      } else if (field.name == "id_card") {
        if (value.length != 13) {
          setErrors({ ...errors, [field.name]: "กรอกเลขบัตรไม่ครบ" });
        } else if (!checkID(value)) {
          setErrors({ ...errors, [field.name]: "เลขบัตรไม่ถูกต้อง" });
        } else {
          setErrors({ ...errors, [field.name]: null });
        }
      }
      setForm({
        ...form,
        [field.name]: value,
      });
      if (errors[field.name] && field.name != "id_card")
        setErrors({
          ...errors,
          [field.name]: null,
        });
    }
  };
  const findFormErrors = () => {
    const {
      id_card,
      pre_name,
      pre_other,
      first_name,
      last_name,
      prov,
      amp,
      tam,
      sex,
      birth_date,
    } = form;
    const newErrors = {};

    // check card error
    if (!id_card || id_card === "") newErrors.id_card = "กรุณากรอกบัตรประชาชน";
    // else if (usertype.length > 2) newErrors.usertype = "name is too long!";

    // prename errors
    if (!pre_name || pre_name === "0") {
      newErrors.pre_name = "กรุณาเลือกคำนำหน้า";
    } else if (pre_name === "อื่นๆ" && (pre_other === "" || !pre_other)) {
      newErrors.pre_other = "กรุณากรอกคำนำหน้า";
    }

    // firstname
    if (!first_name || first_name === "")
      newErrors.first_name = "กรุณากรอกชื่อ";

    // lastname
    if (!last_name || last_name === "") newErrors.last_name = "กรุณากรอกนาสกุล";

    // province
    if (!prov || prov === "") newErrors.prov = "กรุณาเลือกจังหวัด";

    // amphoe
    if (!amp || amp === "") newErrors.amp = "กรุณาเลือกอำเภอ";

    // tam
    if (!tam || tam === "") newErrors.tam = "กรุณาเลือกตำบล";

    // sex
    if (!sex || sex === "") newErrors.sex = "กรุณาเลือกตำบล";

    // birthday
    if (!birth_date || birth_date === "")
      newErrors.birth_date = "กรุณากรอกวันเกิด";

    return newErrors;
  };

  const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
  };

  const handleClickGetPerson = (e) => {
    e.preventDefault();
    const genderText = ["ชาย", "หญิง"];
    const id_card = form.id_card;
    initialForm();
    setForm((a) => ({ ...a, id_card: id_card }));

    if (form.id_card && checkID(form.id_card)) {
      setLoading(true);
      externalService
        .getPersonal({ citizenId: form.id_card, user_id: user.user.user_id })
        .then(async (response) => {
          // alert(JSON.stringify(response.data));
          // console.log(response);
          if (
            response.data.dateOfBirth &&
            response.data.houseID &&
            response.data.statusOfPersonCode != "1" &&
            response.data.statusOfPersonCode != "11"
          ) {
            const checkDate = isValidDate(
              new Date(
                (
                  parseInt(response.data.dateOfBirth.toString().slice(0, 4)) -
                  543
                ).toString() +
                  "-" +
                  response.data.dateOfBirth.toString().slice(4, 6) +
                  "-" +
                  response.data.dateOfBirth.toString().slice(6, 8)
              )
            );
            if (checkDate) {
              setSelectedDate("clear");
              setSelectedDate(
                (
                  parseInt(response.data.dateOfBirth.toString().slice(0, 4)) -
                  543
                ).toString() +
                  "-" +
                  response.data.dateOfBirth.toString().slice(4, 6) +
                  "-" +
                  response.data.dateOfBirth.toString().slice(6, 8)
              );
            } else {
              toast.error(
                "วันเกิดไม่ถูกต้อง->" + response.data.dateOfBirth.toString()
              );
            }

            const setValue = (res, callback) => {
              if (
                res.data.titleDesc == "นาย" ||
                res.data.titleDesc == "นาง" ||
                res.data.titleDesc == "น.ส."
              ) {
                setForm({
                  ...form,
                  ["pre_name"]: res.data.titleDesc,
                });
                setHiddenprename(true);
              } else {
                setForm({
                  ...form,
                  ["pre_name"]: "อื่นๆ",
                  ["pre_other"]: res.data.titleDesc,
                });
                setHiddenprename(false);
              }
              setForm((newform) => ({
                ...newform,
                // ["id_card"]: res.data.data.citizenID,
                ["sex"]: genderText[parseInt(res.data.genderCode) - 1],
                ["first_name"]: res.data.firstName,
                ["last_name"]: res.data.lastName,
                ["address"]: res.data.houseNo
                  ? res.data.houseNo
                  : "" + " " + res.data.alleyWayDesc
                  ? res.data.alleyWayDesc
                  : "" + " " + res.data.alleyDesc
                  ? res.data.alleyDesc
                  : "" + " " + res.data.roadDesc
                  ? res.data.roadDesc
                  : "",
                ["birth_date"]: checkDate
                  ? (
                      parseInt(res.data.dateOfBirth.toString().slice(0, 4)) -
                      543
                    ).toString() +
                    "-" +
                    res.data.dateOfBirth.toString().slice(4, 6) +
                    "-" +
                    res.data.dateOfBirth.toString().slice(6, 8)
                  : "",
              }));
              return callback(res);
            };

            const setLocaton = (res) => {
              const new_prov = prov.filter(
                (o) => o.label == res.data.provinceDesc.replace("จังหวัด", "")
              );
              console.log(new_prov);
              setForm((newform) => ({
                ...newform,
                ["prov"]: new_prov[0].value,
              }));
              TambonService.getByname({
                prov_name: res.data.provinceDesc.replace("จังหวัด", ""),
                amp_name:
                  res.data.provinceDesc.replace("จังหวัด", "") ==
                  "กรุงเทพมหานคร"
                    ? res.data.districtDesc.replace("เขต", "")
                    : res.data.districtDesc.replace("อำเภอ", ""),
                tam_name:
                  res.data.provinceDesc.replace("จังหวัด", "") ==
                  "กรุงเทพมหานคร"
                    ? res.data.subdistrictDesc.replace("แขวง", "")
                    : res.data.subdistrictDesc.replace("ตำบล", ""),
              })
                .then((responseTam) => {
                  // console.log(response.data);
                  const setListAmpTam = (result, callback) => {
                    setAmp([
                      {
                        value: result.data.data.amp,
                        label: result.data.data.amp_namt,
                      },
                    ]);
                    setTam([
                      {
                        value: result.data.data.tambon,
                        label: result.data.data.tam_namt,
                      },
                    ]);
                    return callback(result);
                  };
                  setListAmpTam(responseTam, (a) => {
                    console.log(a);
                    setForm((newform) => ({
                      ...newform,
                      ["amp"]: a.data.data.amp,
                      ["tam"]: a.data.data.tambon,
                    }));
                    // setLoading(false);
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
            };

            setValue(response, setLocaton);
          } else {
            const text_status =
              typeof response.data.statusOfPersonCode !== "undefined" &&
              (response.data.statusOfPersonCode == "1" ||
                response.data.statusOfPersonCode == "11")
                ? response.data.statusOfPersonDesc
                : "ดึงข้อมูลจากทะเบียนราษฎร์ไม่ได้";
            confirmAlert({
              title: "",
              message: text_status,
              buttons: [
                {
                  label: "ปิด",
                  onClick: () => false,
                },
              ],
              overlayClassName: "confirm-alert confirm-alert-onebutton",
            });
          }
        })
        .catch((error) => {
          toast.error("error fetch data: " + error);
        })
        .finally(() => setLoading(false));
    } else {
      toast.error("เลขบัตรประชาชนไม่ถูกต้อง");
    }
  };
  const handleClickReadCard = () => {
    const genderText = ["ชาย", "หญิง"];
    initialForm();
    setLoading(true);
    farmerService
      .readCard()
      .then(async (response) => {
        if (response.data.status === "active") {
          const checkDate = isValidDate(
            new Date(
              (parseInt(response.data.dob.slice(0, 4)) - 543).toString() +
                "-" +
                response.data.dob.slice(4, 6) +
                "-" +
                response.data.dob.slice(6, 8)
            )
          );
          if (checkDate) {
            setSelectedDate("clear");
            setSelectedDate(
              (parseInt(response.data.dob.slice(0, 4)) - 543).toString() +
                "-" +
                response.data.dob.slice(4, 6) +
                "-" +
                response.data.dob.slice(6, 8)
            );
          } else {
            toast.error("วันเกิดไม่ถูกต้อง");
          }

          const setValue = (res, callback) => {
            if (
              res.data.title == "นาย" ||
              res.data.title == "นาง" ||
              res.data.title == "น.ส."
            ) {
              setForm({
                ...form,
                ["pre_name"]: res.data.title,
              });
              setHiddenprename(true);
            } else {
              setForm({
                ...form,
                ["pre_name"]: "อื่นๆ",
                ["pre_other"]: res.data.title,
              });
              setHiddenprename(false);
            }
            setForm((newform) => ({
              ...newform,
              ["id_card"]: res.data.idnumber,
              ["sex"]: genderText[parseInt(res.data.gender) - 1],
              ["first_name"]: res.data.firstname,
              ["last_name"]: res.data.lastname,
              ["address"]: res.data.address1,
              ["birth_date"]: checkDate
                ? (parseInt(res.data.dob.slice(0, 4)) - 543).toString() +
                  "-" +
                  res.data.dob.slice(4, 6) +
                  "-" +
                  res.data.dob.slice(6, 8)
                : "",
            }));
            return callback(res);
          };

          const setLocaton = (res) => {
            const new_prov = prov.filter(
              (o) => o.label == res.data.prov.replace("จังหวัด", "")
            );
            console.log(new_prov);
            setForm((newform) => ({
              ...newform,
              ["prov"]: new_prov[0].value,
            }));
            TambonService.getByname({
              prov_name: res.data.prov.replace("จังหวัด", ""),
              amp_name:
                res.data.prov.replace("จังหวัด", "") == "กรุงเทพมหานคร"
                  ? res.data.amp.replace("เขต", "")
                  : res.data.amp.replace("อำเภอ", ""),
              tam_name:
                res.data.prov.replace("จังหวัด", "") == "กรุงเทพมหานคร"
                  ? res.data.tam.replace("แขวง", "")
                  : res.data.tam.replace("ตำบล", ""),
            }).then((responseTam) => {
              // console.log(response.data);
              const setListAmpTam = (result, callback) => {
                setAmp([
                  {
                    value: result.data.data.amp,
                    label: result.data.data.amp_namt,
                  },
                ]);
                setTam([
                  {
                    value: result.data.data.tambon,
                    label: result.data.data.tam_namt,
                  },
                ]);
                return callback(result);
              };
              setListAmpTam(responseTam, (a) => {
                console.log(a);
                setForm((newform) => ({
                  ...newform,
                  ["amp"]: a.data.data.amp,
                  ["tam"]: a.data.data.tambon,
                }));
                farmerService.getPhotoByCard().then(async (responseImg) => {
                  var imgsrc =
                    "data:image/png;base64," +
                    btoa(
                      String.fromCharCode.apply(
                        null,
                        new Uint8Array(responseImg.data.photo)
                      )
                    );
                  const blob = await fetch(imgsrc).then((resimg) =>
                    resimg.blob()
                  );
                  setForm((newform) => ({
                    ...newform,
                    ["farmerProfileImg"]: blob,
                  }));
                  setImage({
                    preview: URL.createObjectURL(blob),
                  });
                  setLoading(false);
                  setShowCrop(true);
                });
                // setLoading(false);
              });
            });
          };

          setValue(response, setLocaton);
        } else {
          confirmAlert({
            title: "",
            message: "อ่านบัตรประชาชนไม่ได้",
            buttons: [
              {
                label: "ปิด",
                onClick: () => false,
              },
            ],
            overlayClassName: "confirm-alert confirm-alert-onebutton",
          });
        }
      })
      .catch((error) => {
        toast.error(error + " - กรุณาตรวจสอบการเปิดโปรแกรม");
      })
      .finally(() => setLoading(false));
  };

  const handleSubmit = (e) => {
    // console.log(form);
    const newdata = new FormData();
    for (const key in form) {
      newdata.append(key, form[key]);
    }
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      //   console.log("submit");

      // console.log(user);
      setLoading(true);
      farmerService
        .createFarmer(user.user.user_id, newdata)
        .then((response) => {
          if (response.data.success) {
            props.setdata([response.data.data, ...props.data]);
            initialForm();
            props.hidden(false);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const urlImage = (e) => {
    console.log("camera");
    setForm((newform) => ({
      ...newform,
      ["farmerProfileImg"]: e,
    }));
    setImage({
      preview: URL.createObjectURL(e),
    });
    setShowCrop(true);
  };
  const cropImage = (e) => {
    console.log(e);
    setForm((newform) => ({
      ...newform,
      ["farmerProfileImg"]: e.file,
    }));
    setImage({
      preview: e.preview,
    });
  };

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <ModalCrop
        show={showCrop}
        hidden={setShowCrop}
        image={image.preview}
        setCrop={cropImage}
      />
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มเกษตรกร</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="uploadpic">
            <label htmlFor="upload-button">
              {image.preview ? (
                <img src={image.preview} alt="dummy" width="150" height="150" />
              ) : (
                <>
                  <span className="fa-stack fa-2x mt-3 mb-2">
                    <i className="fas fa-circle fa-stack-2x" />
                    <i className="fas fa-store fa-stack-1x fa-inverse" />
                  </span>
                  <h5 className="text-center">Upload your photo</h5>
                </>
              )}
            </label>
            <input
              type="file"
              id="upload-button"
              name="farmerProfileImg"
              style={{ display: "none" }}
              onChange={(e) => setField(e.target, e.target.value)}
            />
            <br />
            {/* <Button variant="primary" type="button" onClick={handleUpload}>
            อัพโหลด
          </Button> */}
          </div>
          <div style={{ textAlign: "center" }}>
            <br />
            {hiddenCamera ? "" : <Webcam urlImage={urlImage} />}
            <button
              className="btn btn-primary"
              onClick={() =>
                hiddenCamera ? setHiddenCamera(false) : setHiddenCamera(true)
              }
              style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
            >
              {hiddenCamera ? "เปิดกล้อง" : "ปิดกล้อง"}
            </button>
          </div>
          <div style={{ textAlign: "center" }}>
            <button
              className="btn btn-primary"
              onClick={handleClickReadCard}
              style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
            >
              คลิ๊กอ่านบัตร
            </button>
          </div>
          <Form>
            <Row>
              <Col md={user.user.user_type != 4 ? "4" : "6"}>
                <Form.Group className="mb-2">
                  <Form.Label>เลขบัตรประชาชน</Form.Label>
                  <FormControl
                    placeholder="เลขบัตรประชาชน"
                    type="number"
                    name="id_card"
                    value={form.id_card}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.id_card}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.id_card}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {user.user.user_type != 4 ? (
                <Col md="2" className="col-custom">
                  <button
                    className="btn btn-primary"
                    onClick={handleClickGetPerson}
                    style={{ padding: ".375rem .75rem", fontSize: "0.8rem" }}
                  >
                    ทะเบียนราษฏร์
                  </button>
                </Col>
              ) : (
                ""
              )}

              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>คำนำหน้า</Form.Label>
                  <Form.Select
                    name="pre_name"
                    value={form.pre_name}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.pre_name}
                  >
                    <option value="0">เลือก...</option>
                    <option value="นาย">นาย</option>
                    <option value="นาง">นาง</option>
                    <option value="น.ส.">น.ส.</option>
                    <option value="อื่นๆ">อื่นๆ</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.pre_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row hidden={hiddenprename}>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อื่นๆ </Form.Label>
                  <FormControl
                    placeholder="คำนำหน้าอื่น ๆ"
                    type="text"
                    name="pre_other"
                    value={form.pre_other}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.pre_other}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.pre_other}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6"></Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อ</Form.Label>
                  <FormControl
                    placeholder="ชื่อ"
                    type="text"
                    name="first_name"
                    value={form.first_name}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.first_name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.first_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>นามสกุล</Form.Label>
                  <FormControl
                    placeholder="นามสกุล"
                    type="text"
                    name="last_name"
                    value={form.last_name}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.last_name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.last_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>เพศ</Form.Label>
                  <Form.Select
                    name="sex"
                    value={form.sex}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.sex}
                  >
                    <option value="">เลือก...</option>
                    <option value="ชาย">ชาย</option>
                    <option value="หญิง">หญิง</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.sex}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>โทร.</Form.Label>
                  <FormControl
                    placeholder="โทร"
                    type="text"
                    name="tel"
                    value={form.tel}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.tel}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tel}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>{!!errors.birth_date}วันที่เกิด</Form.Label>
                  {/* <FormControl
                    placeholder="Birth Day"
                    type="date"
                    name="birth_date"
                    value={form.birth_date}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.birth_date}
                  /> */}
                  {selectedDate == "" || selectedDate != "clear" ? (
                    <WatDatePicker
                      placeholder="เลือกวันเกิด"
                      value={selectedDate} // Can be replace with string or dayjs object (e.g. "2020-12-31" or `dayjs()`)
                      onChange={handleWatDatePickerChange}
                      dateFormat={"yyyy-MM-dd"} // for set data purpose [using date-fns format](https://date-fns.org/v2.12.0/docs/format)
                      displayFormat={"DD MMMM YYYY"} // for display purpose (using dayjs format)[https://day.js.org/docs/en/display/format]
                      inputStyle={errors.birth_date ? invalid : valid} // styles for input
                      clearable={true} // true | false
                      // minDate={"2020-12-26"} // supported date as string
                      maxDate={dayjs().subtract(18, "year")} // also supported dayjs or moment
                      disabled={false} // true | false
                      readOnly={false} // true | false
                      yearBoundary={99} // number of boundary ±X Year
                    />
                  ) : (
                    ""
                  )}

                  <div
                    className={
                      errors.birth_date
                        ? "custom-valid-feedback"
                        : "custom-invalid-feedback"
                    }
                  >
                    {errors.birth_date}
                  </div>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ที่อยู่</Form.Label>
                  <FormControl
                    placeholder="ที่อยู่"
                    type="text"
                    name="address"
                    value={form.address}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.address}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.address}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>จังหวัด</Form.Label>
                  <Form.Select
                    name="prov"
                    value={form.prov}
                    onChange={(e) => handleProvChange(e.target.value)}
                    isInvalid={!!errors.prov}
                  >
                    <option value="">เลือกจังหวัด</option>
                    {prov.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.prov}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อำเภอ</Form.Label>
                  <Form.Select
                    name="amp"
                    value={form.amp || ""}
                    onChange={(e) => handleAmpChange(form.prov, e.target.value)}
                    isInvalid={!!errors.amp}
                  >
                    <option value="">เลือกอำเภอ</option>
                    {amp.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.amp}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ตำบล</Form.Label>
                  <Form.Select
                    name="tam"
                    value={form.tam || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.tam}
                  >
                    <option value="">เลือกตำบล</option>
                    {tam.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.tam}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col></Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            ตกลง
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModaladdFarmer;

ModaladdFarmer.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.array,
  setdata: PropTypes.func,
};
ModaladdFarmer.defaultProps = {
  data: [],
};
